import styled from "styled-components";

// interface IChidlen

export const ContainerTable = styled.div<{
  children: any;
}>`
  margin-top: 20px;
  .green {
    background: #008000 !important;
    color: #ffffff;
  }
  .red {
    background-color: #dc143c !important;
    color: #ffffff;
  }
  .orange {
    background-color: #ff4500 !important;
    color: white;
  }
`;
export const ContainerButton = styled.div<{
  children: any;
}>`
  margin-right: 230px;
`;
